exports.components = {
  "component---src-pages-case-study-minee-wipes-js": () => import("./../../../src/pages/case-study/minee-wipes.js" /* webpackChunkName: "component---src-pages-case-study-minee-wipes-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

